import style from "./style.module.scss";

export default function BlockItem(props) {
  const { messages } = props;
  return (
    <div className={style.block_item} {...props}>
      {messages.map(__message => (
        <div>
          {__message}
        </div>
      ))}
    </div>
  )
}